import { CellContent, TextField } from "@gemini/ui";
import { useMemo, useState } from "react";

import { List } from "../List";

import { ROUTER_ITEMS } from "./constants";
import { createTabPanel } from "./createTabPanel";
import { useAutofocusRef } from "./useAutofocusRef";

export const RouterTabPanel = createTabPanel({
  label: "Router",
  description: "Navigable application paths",
  Component({ isActive }) {
    const inputRef = useAutofocusRef(isActive);
    const [pathFilter, setPathFilter] = useState("");

    const navigableItems = useMemo(() => {
      const filter = pathFilter.trim().toLowerCase();

      return !filter
        ? ROUTER_ITEMS
        : ROUTER_ITEMS.filter(({ id, path }) =>
            `${id} ${path}`.toLowerCase().includes(filter),
          );
    }, [pathFilter]);

    return (
      <>
        <TextField
          ref={inputRef}
          label={{ content: "Filter paths", isHidden: true }}
          onChange={setPathFilter}
          placeholder="Filter paths"
        />
        <List
          marginTop="spacing.12"
          items={navigableItems}
          renderItem={({ id, path, key }) => (
            <CellContent
              key={key}
              href={path.replace("/*", "")}
              title={path}
              description={`${id} ${
                id.startsWith("app_ufrn") ? "example" : "application"
              }`}
            />
          )}
        />
      </>
    );
  },
});
